module.exports = __webpack_public_path__ + "img/loginnew.9ea68e1a.png";